


































































import { Type, TupleType, Expression, ListOps, NullType, ObjectType, Exprs, Types } from 'expangine-runtime';
import { friendlyList } from '../../../common';
import { TypeUpdateEvent } from '../TypeVisuals';
import { getConfirmation } from '../../../app/Confirm';
import { getProgram } from '../../../app/GetProgram';
import { getBuildType } from '../../../app/BuildType';
import { TupleSubs } from './TupleTypes';
import TypeEditorBase from '../TypeEditorBase';
import { sendNotification } from '../../../app/Notify';
import { Preferences, PreferenceCategory } from '../../../app/Preference';


const PREF_TUPLE_REMOVE_ELEMENT = Preferences.define({
  key: 'tuple_remove',
  label: 'Remove element from Tuple without confirmation',
  category: [PreferenceCategory.DESIGN, PreferenceCategory.CONFIRM],
  defaultValue: false,
});


export default TypeEditorBase<TupleType, any, TupleSubs>().extend({
  name: 'TupleEditor',
  methods: {
    requiredTypeFor(index: number) {
      if (!(this.requiredType instanceof TupleType)) {
        return null;
      }

      return this.requiredType.options[index] || NullType.baseType;
    },
    async removeType(index: number, innerType: Type) {
      if (!await getConfirmation({ pref: PREF_TUPLE_REMOVE_ELEMENT })) {
        return;
      }

      this.type.options.splice(index, 1);
      this.settings.sub.splice(index, 1);

      this.inputSelected.onSubRemove(index, this.type, this.settings);

      const transform = this.type.getValueChangeExpression(Exprs.noop(), index, undefined);

      this.change({ transform });
    },
    async addType(index: number, afterType: Type) {
      const chosen = await getBuildType({
        input: {
          registry: this.registry,
        },
        title: `Add Type [${index + 2}]`,
        ok: 'Add',
      });

      if (!chosen) {
        return;
      }

      const updateEvent: Partial<TypeUpdateEvent> = {};

      if (!this.noTransform) {
        const result = await getProgram({
          title: `Add element "${index + 1}"`,
          message: 'The default value for the new element.',
          confirm: 'Add',
          registry: this.registry,
          context: Types.object({
            parent: this.type,
          }),
          program: this.registry.getTypeCreate(chosen.type),
          expectedType: chosen.type,
        });

        if (!result) {
          return sendNotification({ message: 'Element add canceled.' });
        }

        updateEvent.transform = this.type.getValueChangeExpression(result.program, undefined, index + 1);
      }

      this.type.options.splice(index + 1, 0, chosen.type);
      this.settings.sub.splice(index + 1, 0, chosen.settings);

      this.inputSelected.onSubAdd(index + 1, this.type, this.settings);

      this.change(updateEvent);
    },
    onChange(index: number, innerType: Type, event: TypeUpdateEvent) {
      this.$set(this.type.options, index, event.type);
      this.$set(this.settings.sub, index, event.settings);
      
      const transform = event.transform
        ? this.type.getValueChangeExpression(event.transform, index, index)
        : undefined;
      
      this.change({ transform });
    },
  },
});
